import axios from 'axios'
import store from '@/store'

// 타임아웃 시간
axios.defaults.timeout = 70 * 1000;
axios.defaults.headers['Pragma'] = 'no-cache';

axios.interceptors.request.use(config => {
    config.headers.authorization = 'token'
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Credentials'] = true;
    config.headers['Access-Control-Allow-Headers'] = 'Authorization';
    if (store.state.userStore) {
        config.headers['accessToken'] = store.state.userStore.accToken;
        config.headers['refreshToken'] = store.state.userStore.refToken;
    }
    store.commit('set', ['loading', true]);
    return config;
}, () => {
    store.commit('set', ['loading', false]);
});

let isAuthErrorOccurred = false;

axios.interceptors.response.use(response => {
    store.commit('set', ['loading', false]);
    if (response.data && response.data.data && response.data.data.token) {
        if (response.data.data.token.accessToken) {
            store.commit('userStore/set', ['accToken', response.data.data.token.accessToken])
        }
        if (response.data.data.token.refreshToken) {
            store.commit('userStore/set', ['refToken', response.data.data.token.refreshToken])
        }
    }

    // token 만료된 경우
    if (response.data) {
        if (response.data.msg) {
            // 토큰 Error
            if (!response.data.result) {
                if (response.data.msg.code === 'TOKEN_EXPIRED' || response.data.msg.code === 'INVALID_TOKEN') {
                    // 이미 에러 페이지라면 리다이렉트 중단 (무한 루프 방지)
                    if (location.pathname !== '/error') {
                        location.replace(`/error`);
                    }
                    return Promise.reject(new Error(response.data.msg.message || 'Token Error'));
                }

                if (response.data.msg.code === 'OAUTH_NOT_EXISTS') {
                    if (!isAuthErrorOccurred) {
                        isAuthErrorOccurred = true;
                        // 디자인된 팝업 사용 (서버에서 온 메시지 우선 사용)
                        const alertMsg = response.data.msg.message || '권한이 없거나 사용자 정보가 없습니다.';
                        store.commit('set', ['msg', alertMsg]);
                        store.commit('set', ['ntcPopOnClose', () => {
                            isAuthErrorOccurred = false;
                            // 메인인 스케줄 페이지로 이동 (이미 해당 페이지면 이동 안 함)
                            if (location.pathname !== '/schedInfo') {
                                location.replace('/schedInfo');
                            }
                        }]);
                        store.commit('set', ['ntcPopShow', true]);
                    }
                    // 이미 핸들링된 인증 에러임을 표시하여 컴포넌트에서 무시할 수 있게 함
                    return Promise.reject({ _handled: true, ...response.data });
                }
            }
        }
    }
    return response
}, (error) => {
    store.commit('set', ['loading', false]);
    if (location.pathname !== '/error') {
        location.replace('/error');
    }
    return Promise.reject(error);
})
export default axios;